import { UserCollectionsState, CustomInputMappingState, OpenCollectionsState } from "../../redux"
import { Document, Collection, DocumentDataType } from "../../models"
import { DocumentPermissionsRequest, getPrivateDocumentPermission, getLimitedDocumentPermission, getGroupDocumentPermission, getPublicDocumentPermission } from "../../models/DocumentPermissionRequest"

export const getDocumentPermissionMoveOption = (document: Document): DocumentPermissionsRequest => {
    if (document.isPrivate) {
        return getPrivateDocumentPermission()
    } else if (document.isLimitedToMembers) {
        return getLimitedDocumentPermission()
    } else if (document.groupUid) {
        return getGroupDocumentPermission(document.groupUid)
    }

    return getPublicDocumentPermission()
}

type GetPermissionsMoveOptionsAdditional = {
    openCollections?: OpenCollectionsState
}
export const getPermissionsMoveOptions = (userCollections: UserCollectionsState, customInputMappings: CustomInputMappingState, additional?: GetPermissionsMoveOptionsAdditional) =>
    (dataType: DocumentDataType): DocumentPermissionsRequest[] => {
        let openCollectionsOptions: DocumentPermissionsRequest[] = []

        const userCollectionsOptions: DocumentPermissionsRequest[] = userCollections.data
            .filter(x => isDataTypeAllowedInCollection(dataType, x))
            .map(x => getGroupDocumentPermission(x.collectionGroup.groupUid))
        
        if(!!additional && !!additional.openCollections) {
            openCollectionsOptions = additional.openCollections.data
                .filter((x) => !userCollectionsOptions.find((g) => g.groupUid === x.collectionGroup.groupUid))
                .filter(x => isDataTypeAllowedInCollection(dataType, x))
                .map(x => getGroupDocumentPermission(x.collectionGroup.groupUid))
        }

        let options: DocumentPermissionsRequest[] = []
        const customInputMapping = customInputMappings.data.find(x => x.customDataMapping.dataTypeFilter === dataType)
        if (!customInputMapping || customInputMapping.enablePublishingToPublicFeed) {
            options.push(getPublicDocumentPermission())
        }

        options = [...options, getPrivateDocumentPermission(), getLimitedDocumentPermission(), ...userCollectionsOptions, ...openCollectionsOptions]

        return options
    }

const isDataTypeAllowedInCollection = (dataType: DocumentDataType, collection: Collection): boolean => {
    const isDocumentDataTypeInAllowedInputs = collection.settings.allowedInputs.find(x => x === dataType)

    const isAllowed = collection.allInputsAllowed || isDocumentDataTypeInAllowedInputs
    return !!isAllowed
}

export const getPermissionGroupText = (tranlsations: { groupsLabel: string }) => (documentPermission: DocumentPermissionsRequest): string => {
    if (documentPermission.groupUid) {
        return tranlsations.groupsLabel
    } else {
        return ''
    }
}

export interface PermissionLabelsTranslations {
    private: string
    public: string
    limited: string
    unknown: string
}

type GetPermissionOptionLabelAdditional = {
    openCollections?: OpenCollectionsState
}

export const getPermissionOptionLabel = (translations: PermissionLabelsTranslations) =>
    (userCollections: UserCollectionsState, additional?: GetPermissionOptionLabelAdditional) =>
        (option: DocumentPermissionsRequest): string => {
            if (option.isPrivate) {
                if (option.isLimitedToMembers) {
                    return translations.limited
                } else {
                    return translations.private
                }
            } else {
                if (option.groupUid) {
                    const collections = [...userCollections.data] 

                    if(!!additional && !!additional.openCollections) {
                        collections.push(...additional.openCollections.data)
                    }

                    const collection = collections.find(x => x.collectionGroup.groupUid === option.groupUid)
                    if (collection) {
                        return collection.title
                    } else {
                        return translations.unknown
                    }
                } else {
                    return translations.public
                }
            }
        }